import React from "react";

const DataPrivacy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="max-w-5xl mx-auto px-6">
        <h1 className="text-4xl font-bold text-center mb-12">Data Privacy & Policies</h1>
        <p className="text-gray-700 text-lg leading-relaxed mb-6">
          Your privacy is important to us. All personal and academic information
          collected during the bursary application process is securely stored
          and used solely for verification and allocation purposes.
        </p>
        <p className="text-gray-700 text-lg leading-relaxed mb-6">
          We comply with national data protection laws, ensuring that your information
          is not shared without consent. Students can request corrections or removal
          of their data at any time through the bursary office.
        </p>
        <p className="text-gray-700 text-lg leading-relaxed">
          By submitting your application, you agree to the platform's terms of use
          and data privacy policies.
        </p>
      </div>
    </div>
  );
};

export default DataPrivacy;
